import { Component, OnInit, OnDestroy, ViewChild, TemplateRef } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalService } from '../../services/modal.service';
import { Subscription } from 'rxjs';
import { ModalArgs, ModalMessage, ModalStates } from '../../models/modal';

@Component({
  selector: 'lib-alert-modal', // implemented on app.component.html
  templateUrl: './alert-modal.component.html',
  styleUrls: ['./alert-modal.component.css'],
  standalone: false
})
export class AlertModalComponent implements OnInit, OnDestroy {
  @ViewChild('alertModalRef', { static: true }) public alertModalRef: TemplateRef<any>;

  private sub: Subscription;
  private queue: ModalArgs[] = [];
  private isOpen = false;

  public header: string;
  public headerIcon: string;
  public okBtnText: string;
  public message: ModalMessage;
  public hideOkButton: boolean = false;

  constructor(
    private modalService: ModalService,
    private ngbModalService: NgbModal,
    private router: Router
  ) {}

  ngOnInit() {
    this.sub = this.modalService.alertModalToggle.subscribe((value: ModalArgs) => {
      this.queue.push(value);
      this.handleQueue();
    });
  }

  closeAlert(value: ModalArgs) {
    this.isOpen = false;
    this.queue.shift();
    this.handleQueue();

    if (value.RouteCommands !== null && value.RouteCommands !== undefined) {
      this.router.navigate(value.RouteCommands);
    }
  }

  handleQueue() {
    if (!this.isOpen && this.queue.length > 0) {
      this._openModal(this.queue[0]);
    }
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  private _openModal(value: ModalArgs) {
    this.isOpen = true;
    this.message = value.Message;
    this.okBtnText = value.ConfirmButtonText;
    this.header = this._setHeader(value);
    this.hideOkButton = value.HideOkButton;
    this.ngbModalService
      .open(this.alertModalRef, {
        size: 'lg',
        windowClass: `alert-modal-${ModalStates[value.State].toLowerCase()} centered`
      })
      .result.then(
        // close
        () => this.closeAlert(value),
        // dismiss
        () => this.closeAlert(value)
      );
  }

  private _setHeader(args: ModalArgs): string {
    if (args.Header) {
      return args.Header;
    } else {
      switch (args.State) {
        case ModalStates.Error: {
          this.headerIcon = 'fas fa-exclamation-circle';
          return 'Error';
        }
        case ModalStates.Warning: {
          this.headerIcon = 'fas fa-exclamation-circle';
          return 'Warning';
        }
        case ModalStates.Success: {
          this.headerIcon = 'fas a-check-circle';
          return 'Success';
        }
        case ModalStates.Info: {
          this.headerIcon = 'fas fa-info-circle';
          return 'Info';
        }
      }
    }
  }
}
